module.exports = new __parcel__URL__("pages-multimedia.20df3555.svg").toString();